import React from "react";
import FontAwesome from "react-fontawesome";
import "./../../card.css";
const PermitList = ({ list, handleDelete }) => {
  //console.log(list);

  return (
    <>
      {list &&
        list.map((item, index) => {
          return (
            <div key={item.no}>
              <div className="row">
                <div className="col-lg-1">
                  <span className="badge rounded-pill bg-primary">
                    {item.no}
                  </span>
                  <span className="badge rounded-pill bg-primary">
                    {item.parkname}
                  </span>
                </div>
                <div className="col-lg-6">
                  <div className=" d-flex justify-content-center">
                    <img
                      className="img-fluid img-thumbnail"
                      src={item.url}
                      alt=""
                      style={{
                        maxHeight: "500px",
                        maxWidth: "600px",
                      }}
                    />
                  </div>

                  {/* <span className="tooltip-content clearfix">
                                <img
                                  className="personTooltip"
                                  src={item.url}
                                  alt=""
                                  style={{
                                    width: "100%",
                                    minHeight: "400px",
                                    minWidth: "450px",
                                  }}
                                />

                                <span className="tooltip-text"></span>
                              </span> */}
                </div>
                <div className="col-lg-3 ">
                  <div
                    className="row d-flex justify-content-start"
                    style={{ fontSize: "14px" }}
                  >
                    <p className="font-weight-normal">
                      ยอดโอน:{item.totalpay} บาท
                    </p>

                    <p
                      className="font-weight-normal"
                      style={{ fontSize: "14px" }}
                    >
                      เดือน:{item.payfrom} - {item.payto}
                    </p>

                    <p
                      className="font-weight-normal"
                      style={{ fontSize: "14px" }}
                    >
                      โดย:{item.fname} {item.lname}
                    </p>

                    <p
                      className="font-weight-normal"
                      style={{ fontSize: "14px" }}
                    >
                      วันที่:{item.uploaddate}
                    </p>
                  </div>
                </div>
                <div className="m-1">
                  <div className="row d-flex justify-content-center">
                    <div className="col-lg-3 mt-2">
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(item.id)}
                      >
                        <FontAwesome name="fa-trash" /> Delete
                      </button>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          );
        })}
    </>
  );
};

export default PermitList;
